import {Component, input} from '@angular/core';
import {ActionMenuItem} from '../../models/action-menu-item.class';
import {NgClass} from '@angular/common';
import {MatIconButton} from '@angular/material/button';
import {MatTooltip} from '@angular/material/tooltip';
import {MatIcon} from '@angular/material/icon';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';

@Component({
  selector: 'app-card-menu-item',
  templateUrl: './card-menu-item.component.html',
  styleUrl: './card-menu-item.component.scss',
  imports: [
    NgClass,
    MatIconButton,
    MatTooltip,
    MatIcon,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
  ]
})
export class CardMenuItemComponent {
  readonly item = input<ActionMenuItem>();
}
